/**
 * Name and Value display component
 *
 * @module @features/departments/components/NameAndValue
 */

import React from 'react';
import styles from '../MyDepartments.module.css';

/**
 * Props for NameAndValue component
 */
export interface NameAndValueProps {
    name: React.ReactNode;
    value: React.ReactNode;
}

/**
 * Displays a name-value pair
 */
export function NameAndValue({
    name,
    value,
}: NameAndValueProps): React.ReactElement {
    return (
        <div className={styles.nameAndValue}>
            <span className={styles.nameAndValueName}>{name}</span>
            <span className={styles.nameAndValueValue}>{value}</span>
        </div>
    );
}
